import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map, catchError, tap, switchMap } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { BaseService } from "./base.service";
import { Metadata } from "../models/metadata";
import { IAppStore } from "../iappstore";
import { Store } from "@ngrx/store";

/**
 * @whatItDoes A service for anything item related
 *
 * @howToUse Inject the service
 */
@Injectable()
export class MetadataService extends BaseService {
    /**
     * Constructor for service
     * @param http angular http module
     * @param toastr toastr manager
     * @param authService Authentication Service
     */
    constructor(httpClient: HttpClient, toastr: ToastrService, store: Store<IAppStore>) {
        super(httpClient, toastr, store);
    }

    /**
     * Returns an observable single metadata item
     */
    getMetadata(id: number): Observable<Metadata> {
        return super.get(`/api/metadataconfig/${id}`).pipe(map((res: any) => res));
    }

    /**
     * Returns an observable collection of metadata for the current business function
     */
    getAllMetadataByCountry(countryCode: string): Observable<Metadata[]> {
        return super.get(`/api/metadataconfig/getbycountry/${countryCode}`).pipe(map((res: any) => res));
    }

    /**
     * Returns an observable collection of metadata for the current business function
     */
    getAllMetadata(): Observable<Metadata[]> {
        return super.get("/api/metadataconfig").pipe(map((res: any) => res));
    }

    /**
     * Returns an observable of the id of the metadata created
     * @param item The item to create
     */
    create(metadata: Metadata): Observable<number> {
        return super.post("/api/metadataconfig", metadata).pipe(map((res: any) => res as number));
    }

    /**
     * Returns an observable of the boolean response from the update request
     * @param item The item to create
     */
    update(metadata: Metadata): Observable<boolean> {
        return super.put("/api/metadataconfig", metadata).pipe(map((res: any) => res as boolean));
    }
}





